module.exports = __webpack_public_path__ + "img/btx.5fc7218f.svg";